export default __webpack_public_path__ + "static/media/nectar_c_energy.b59f4946.png";